import { ReservationType } from "src/utils/common";
import VoucherSection from "./VoucherSection";

const VoucherSectionsContainer = ({ clientVoucherDetails, headerImage, voucherDetails }) => {
    if (!clientVoucherDetails) return null;

    return (
        <>
            {/* Render hotel sections */}
            {clientVoucherDetails.Hotels?.map((hotel, index) => (
                <VoucherSection
                    key={`hotel-${index}`}
                    type={ReservationType.hotel}
                    provider={hotel}
                    headerImage={headerImage}
                    voucherDetails={voucherDetails}
                    clientVoucherDetails={clientVoucherDetails}
                />
            ))}

            {/* Render service sections */}
            {clientVoucherDetails.Services?.map((service, index) => (
                <VoucherSection
                    key={`service-${index}`}
                    type={ReservationType.service}
                    provider={service}
                    headerImage={headerImage}
                    voucherDetails={voucherDetails}
                    clientVoucherDetails={clientVoucherDetails}
                />
            ))}
        </>
    );
};

export default VoucherSectionsContainer;